import React, { useState, useEffect, useRef } from "react";
import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { FormProvider } from "@/integrations/forms/FormProvider";
const getReferrerMacros = () => {
  if (typeof window === "undefined") return {};
  const params = new URLSearchParams(window.location.search);
  return {
    click_id: params.get("click_id") || undefined,
    ad_id: params.get("ad_id") || undefined,
    campaign_id: params.get("campaign_id") || undefined,
    ad_group_id: params.get("ad_group_id") || undefined,
    ad_account_id: params.get("ad_account_id") || undefined,
    snuuid: params.get("snuuid") || undefined
  };
};
const products = [{
  rank: 1,
  badge: "#1 Teeth Whitening Product",
  isTop: true,
  image: "https://verifiedandranked.com/wp-content/uploads/2026/06/280c90b25dae2375387b3ce655eb3a35e246f051_original.jpeg?v=yrk34obvi3p",
  imageAlt: "YOUBUY SIMPLY WHITE Whitening Powder",
  caption: "YOUBUY SIMPLY WHITE",
  pros: ["Achieved superior shade improvement", "Results visible after initial application", "Works on coffee, tea, wine, tobacco, and age-related yellowing", "Results held longer than other products after stopping use", "Powder reaches every tooth surface including gaps (no uneven whitening like strips)", "One container lasts 2+ months of daily use ($0.50/day)", "No sensitivity reported by our testers during the trial", "PAP+ whitening with hydroxyapatite helps protect enamel while whitening", "No strips, no trays, no LED devices needed", "Safe for crowns, veneers, and dental work"],
  cons: ["Not available on Amazon or in retail stores (official website only)", "Frequently sells out during promotional periods"],
  score: "9.8",
  scoreLabel: "HIGHEST RATED IN OUR TESTING",
  buttonLabel: "VISIT SITE",
  buttonHref: "https://simplywhiteteeth.com/products/maximum-whitening-bundle",
  price: "$29.99",
  priceCrossed: "$59.98",
  shipping: "1-3 Days Express Shipping",
  amazonLogo: null,
  stars: 5,
  reviewText: "5,000+ users gave this brand 4.9 Stars"
}, {
  rank: 2,
  badge: "2",
  isTop: false,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688765/img/crest-whitestrips.jpg",
  imageAlt: "Crest 3D White Professional Effects Whitestrips",
  caption: "CREST 3D WHITESTRIPS",
  pros: ["ADA Seal of Acceptance for safety and efficacy", "Visible results within the first 3 days", "Advanced Seal Technology keeps strips in place", "22 treatments per kit (44 strips total)", "94,000+ Amazon ratings with 4.6 star average", "One of the most widely available whitening brands", "30+ years on the market"],
  cons: ["Hydrogen peroxide causes significant tooth sensitivity in most users", "Strips miss gaps between teeth, causing uneven whitening"],
  score: "9.4",
  scoreLabel: "2,500+ USERS GAVE THIS BRAND 4.5 STARS",
  buttonLabel: "VISIT AMAZON",
  buttonHref: "https://www.amazon.com/Crest-3DWhitestrips-Radiant-Whitening-Treatments/dp/B09S8JPWMK",
  price: "$70.40",
  priceCrossed: null,
  shipping: "2-5 Days Standard Shipping",
  amazonLogo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688765/img/amazon.svg",
  stars: 4.5,
  reviewText: "2,500+ users gave this brand 4.5 Stars"
}, {
  rank: 3,
  badge: "3",
  isTop: false,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688765/img/laughland-whitening.jpg",
  imageAlt: "LaughLand Teeth Whitening Kit",
  caption: "LAUGHLAND",
  pros: ["Only whitening system that personalizes the formula to YOUR teeth — a sensitivity quiz matches you to one of three custom formulas designed for your exact dental profile", "FDA-registered LED mouthpiece powered by your smartphone (no batteries, no charging)", "Clinical study: 0% of participants reported increased sensitivity", "Visible whitening results reported within 6 days of use", "Quick 10-minute daily sessions that fit easily into any routine", 'Forbes Vetted "Best Teeth Whitening with Fast Results"', "Women's Health Beauty Award winner for Best Teeth Whitening Product", "Formulated with aloe vera and natural mint for a gentle, comfortable experience"],
  cons: ["LED mouthpiece plugs into your phone, so your phone is occupied during each session", "Not as widely available in retail stores as some competitors"],
  score: "9.1",
  scoreLabel: "1,500+ USERS GAVE THIS BRAND 4.5 STARS",
  buttonLabel: "VISIT SITE",
  buttonHref: "https://www.amazon.com/Laughland-Whitening-Phone-Powered-Mouthpiece-Treatments/dp/B0FKCW9VY3",
  price: "$59.00",
  priceCrossed: null,
  shipping: "2-5 Days Standard Shipping",
  amazonLogo: null,
  stars: 4.5,
  reviewText: "1,500+ users gave this brand 4.5 Stars"
}, {
  rank: 4,
  badge: "4",
  isTop: false,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688765/img/snow-whitening.jpg",
  imageAlt: "Snow Teeth Whitening Kit",
  caption: "SNOW",
  pros: ["LED light mouthpiece accelerates whitening process", "Includes hydroxyapatite for enamel protection", "9-minute daily sessions (shorter than most strips)", "Pen-style serum wands for precise application", "Featured on Shark Tank, sold at Target and Nordstrom", "75+ treatments per 3-wand kit", "5-year warranty on LED mouthpiece", "Clinically tested, manufactured in FDA-registered facility"],
  cons: ["Premium pricing and requires LED device for every session", "Refill wands add to ongoing cost over time"],
  score: "8.9",
  scoreLabel: "1,700+ USERS GAVE THIS BRAND 4 STARS",
  buttonLabel: "VISIT AMAZON",
  buttonHref: "https://www.amazon.com/SNOW-Whitening-Complete-Mouthpiece-Whitener/dp/B07GZ75Y3F",
  price: "$99.00",
  priceCrossed: null,
  shipping: "2-5 Days Standard Shipping",
  amazonLogo: null,
  stars: 4,
  reviewText: "1,700+ users gave this brand 4 Stars"
}, {
  rank: 5,
  badge: "5",
  isTop: false,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688765/img/lumineux-strips.jpg",
  imageAlt: "Lumineux Whitening Strips",
  caption: "LUMINEUX",
  pros: ["100% peroxide-free, uses natural coconut and sage oils", "Certified non-toxic formula", "Dentist formulated (Dr. Kourosh Maddahi)", "Zero sensitivity during and after treatment", "Safe for crowns, veneers, and dental work", "Amazon #1 Best Seller in teeth whitening", "25,000+ Amazon ratings with 4.5 star average"],
  cons: ["Limited whitening power, especially on deeper stains"],
  score: "8.6",
  scoreLabel: "650+ USERS GAVE THIS BRAND 3.5 STARS",
  buttonLabel: "VISIT AMAZON",
  buttonHref: "https://www.amazon.com/Lumineux-Teeth-Whitening-Strips-Treatments-Enamel-Safe/dp/B082TPDTM2",
  price: "$44.99",
  priceCrossed: null,
  shipping: "2-5 Days Standard Shipping",
  amazonLogo: null,
  stars: 3.5,
  reviewText: "650+ users gave this brand 3.5 Stars"
}];
function StarRating({
  stars
}: {
  stars: number;
}) {
  return <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map(s => <svg key={s} className={`w-4 h-4 ${s <= Math.floor(stars) ? "text-amber-400" : s - 0.5 === stars ? "text-amber-400" : "text-gray-200"}`} fill="currentColor" viewBox="0 0 20 20">
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>)}
    </div>;
}
function AnimatedCard({
  children,
  delay = 0
}: {
  children: React.ReactNode;
  delay?: number;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setTimeout(() => setVisible(true), delay);
        observer.disconnect();
      }
    }, {
      threshold: 0.1
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [delay]);
  return <div ref={ref} className={`transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
      {children}
    </div>;
}
function ScoreArc({
  score,
  isTop
}: {
  score: string;
  isTop?: boolean;
}) {
  const value = parseFloat(score);
  const pct = value / 10 * 100;
  const circumference = 2 * Math.PI * (isTop ? 51.75 : 45);
  const dash = pct / 100 * circumference;
  return <div className="relative inline-flex items-center justify-center min-w-[80px] min-h-[80px]">
      <svg width={isTop ? 126.5 : 110} height={isTop ? 126.5 : 110} viewBox="0 0 110 110" className="-rotate-90">
        <circle cx="55" cy="55" r={isTop ? 51.75 : 45} fill="none" stroke="#e5e7eb" strokeWidth="7" />
        <circle cx="55" cy="55" r={isTop ? 51.75 : 45} fill="none" stroke={`url(#scoreGrad-${isTop ? 'top' : 'default'})`} strokeWidth="7" strokeDasharray={`${dash} ${circumference}`} strokeLinecap="round" />
        <defs>
          <linearGradient id={`scoreGrad-${isTop ? 'top' : 'default'}`} x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor={isTop ? "#16a34a" : "#94a3b8"} />
            <stop offset="100%" stopColor={isTop ? "#16a34a" : "#64748b"} />
          </linearGradient>
        </defs>
      </svg>
      <span className={`absolute font-black text-foreground tracking-tight ${isTop ? "text-3xl" : "text-2xl"}`}>{score}</span>
    </div>;
}
export default function ProductRankingsList() {
  const macros = getReferrerMacros();
  const getUrlWithMacros = (baseUrl: string) => {
    try {
      const url = new URL(baseUrl);
      Object.entries(macros).forEach(([key, value]) => {
        if (value) url.searchParams.set(key, value);
      });
      return url.toString();
    } catch (e) {
      return baseUrl;
    }
  };
  return <section className="text-foreground py-12 px-4 md:px-8 max-w-5xl mx-auto bg-background">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');
        @keyframes pulse-scale { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.04); } }
      `}</style>

      <div className="space-y-8">
        {products.map((product, idx) => {
        const cardContent = <Card data-index={idx} className={`overflow-visible md:overflow-hidden border-0 shadow-none rounded-2xl ${idx === 0 ? "cursor-pointer" : ""} ${product.isTop ? "ring-2 ring-black shadow-xl shadow-gray-200 bg-card" : "ring-1 ring-border bg-card"}`}>
              <div className="p-5 md:p-7">
                <div className="flex flex-col md:flex-row gap-6 md:gap-8">

                  <div className={`flex flex-col md:flex-row items-center gap-4 md:gap-3 ${idx === 0 ? "md:w-[300px]" : "md:w-44"} shrink-0`}>
                    <div className={`shrink-0 w-full order-1 md:order-2`}>
                      {product.isTop ? <div className="mb-3">
                          <span className="from-violet-600 to-indigo-500 text-white font-bold tracking-wide px-2 py-1 rounded-md uppercase shadow-md inline-block !text-center !text-lg !bg-[rgba(0,0,0,1)]">
                            #1 Teeth Whitening Product
                          </span>
                          <p className="font-medium text-gray-700 mt-2 !text-center !text-sm">
                            Whitens 2–4 shades in 14 days — without peroxide or sensitivity.
                          </p>
                        </div> : <div className="relative">
                          <div className="absolute -top-2 -left-2 z-10 w-8 h-8 rounded-lg bg-foreground flex items-center justify-center shadow">
                            <span className="text-background text-sm font-black">{product.rank}</span>
                          </div>
                        </div>}
                      <div className={`rounded-2xl overflow-hidden bg-white ${idx === 0 ? "" : "border-2 border-border/60"} p-5 mx-auto md:mx-0 relative`} style={{
                    width: idx === 0 ? 300 : 180,
                    height: idx === 0 ? 300 : 180
                  }}>
                        {idx === 0 && <div className="absolute top-2 left-2 z-20 bg-[#16a34a] text-white text-xs font-bold px-2 py-1 shadow-lg -rotate-10">
                             BEST VALUE
                          </div>}
                        {idx === 0 ? <Link to={getUrlWithMacros("https://simplywhiteteeth.com/products/maximum-whitening-bundle")} newTab><img src={product.image} alt={product.imageAlt} className="w-full h-auto object-contain" /></Link> : <img src={product.image} alt={product.imageAlt} className="w-full h-auto object-contain" />}
                      </div>
                      
                      <div className="hidden md:block mt-4 text-center">
                        <ScoreArc score={product.score} isTop={idx === 0} />
                        <p className="text-[9px] font-bold tracking-widest text-muted-foreground uppercase mt-1">Overall Score</p>
                        <p className="text-base tracking-wide mt-0.5 !text-[rgba(0,0,0,1)] !font-semibold">
                          {product.scoreLabel}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="flex-1 min-w-0">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
                      <div>
                        <p className="text-xs font-bold uppercase tracking-wider text-emerald-800 mb-3">Pros</p>
                        <ul className="space-y-3">
                          {product.pros.map((pro, i) => <li key={i} className="grid grid-cols-[auto_1fr] items-start gap-2 text-[16px] leading-[1.55] text-gray-800">
                              <span className="mt-1 shrink-0 w-4 h-4 rounded-lg bg-emerald-100 flex items-center justify-center">
                                <svg className="w-2.5 h-2.5 text-emerald-600" fill="none" viewBox="0 0 12 12" stroke="currentColor" strokeWidth="2.5">
                                  <path strokeLinecap="round" strokeLinejoin="round" d="M2 6l3 3 5-5" />
                                </svg>
                              </span>
                              <span>{pro}</span>
                            </li>)}
                        </ul>
                      </div>

                      <div>
                        <p className="text-xs font-bold uppercase tracking-wider text-red-700 mb-3">Cons</p>
                        <ul className="space-y-3">
                          {product.cons.map((con, i) => <li key={i} className="grid grid-cols-[auto_1fr] items-start gap-2 text-[16px] leading-[1.55] text-gray-800">
                              <span className="mt-1 shrink-0 w-4 h-4 rounded-lg bg-rose-100 flex items-center justify-center">
                                <svg className="w-2.5 h-2.5 text-red-600" fill="none" viewBox="0 0 12 12" stroke="currentColor" strokeWidth="2.5">
                                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 3l6 6M9 3l-6 6" />
                                </svg>
                              </span>
                              <span>{con}</span>
                            </li>)}
                        </ul>
                      </div>
                    </div>

                    <Separator className="mb-4 opacity-50" />

                    <div className="block md:hidden mt-4 mb-6 text-center">
                      <ScoreArc score={product.score} isTop={idx === 0} />
                      <p className="text-[9px] font-bold tracking-widest text-muted-foreground uppercase mt-1">Overall Score</p>
                      <p className="text-base tracking-wide mt-0.5 !text-[rgba(0,0,0,1)] !font-semibold">
                        {product.scoreLabel}
                      </p>
                    </div>

                    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                      <div className="flex flex-col gap-1">
                        {product.reviewText && <div className="flex items-center gap-2 text-center">
                            <StarRating stars={product.stars} />
                            <span className="text-xs text-muted-foreground">{product.reviewText}</span>
                          </div>}
                        <div className="flex flex-col gap-1">
                          <div className="flex items-baseline gap-2">
                            <span className="text-2xl font-black text-foreground">
                              {product.price}
                            </span>
                            {product.priceCrossed && <span className="text-sm text-muted-foreground line-through">{product.priceCrossed}</span>}
                          </div>
                          <div className="flex items-center gap-1.5">
                            <svg className="w-3.5 h-3.5 text-muted-foreground shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                              <path strokeLinecap="round" strokeLinejoin="round" d="M20 12V22H4V12M22 7H2v5h20V7zM12 22V7M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z" />
                            </svg>
                            <span className={`text-xs font-medium ${product.shipping.includes("Free") ? "text-emerald-600" : "text-muted-foreground"}`}>
                              {product.shipping}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="flex flex-col items-center sm:items-end gap-2 w-full sm:w-auto">
                        {idx === 0 && <Link to={getUrlWithMacros("https://simplywhiteteeth.com/products/maximum-whitening-bundle")} newTab className="cursor-pointer">
                            <div className="relative inline-flex flex-col items-center">
                              <FormProvider>
                                <div className="relative bg-red-600 text-white py-1 px-3 rounded-md uppercase tracking-wider shadow-sm !w-[201.317px] !text-center !text-sm flex items-center justify-center gap-2">
                                  50% OFF! - JUNE SALE STARTS TODAY!
                                  <ChevronDown className="w-4 h-4" />
                                  <div className="absolute -bottom-1.5 left-1/2 -translate-x-1/2 w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-red-600" />
                                </div>
                              </FormProvider>
                            </div>
                          </Link>}
                        <Button asChild={idx !== 0} className={`inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive h-9 has-[>svg]:px-3 ${idx === 0 ? "mx-auto w-auto" : "w-auto"} font-black tracking-widest rounded-xl uppercase transition-all duration-200 text-white shadow-xl !font-mono disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 sm:w-auto ${idx === 0 ? "bg-[#16a34a] px-10 py-8 !text-2xl hover:bg-[#15803d] hover:scale-110" : "bg-white border-2 border-gray-300 text-gray-700 hover:bg-gray-50 hover:scale-100 px-8 py-7 !text-xl"}`}>
                          {idx === 0 ? <Link to={getUrlWithMacros(product.buttonHref)} newTab>{product.buttonLabel}</Link> : <Link to={getUrlWithMacros(product.buttonHref)} newTab={idx === 2}>Check Price</Link>}
                        </Button>
                        {product.amazonLogo && <div className="flex justify-center sm:justify-end">
                            <img src={product.amazonLogo} alt="Amazon" className="w-auto h-5 object-contain opacity-70" />
                          </div>}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Card>;
        return <AnimatedCard key={product.rank} delay={0}>
            {idx === 0 ? <Link to={getUrlWithMacros("https://simplywhiteteeth.com/products/maximum-whitening-bundle")} newTab className="block no-underline">
                {cardContent}
              </Link> : cardContent}
          </AnimatedCard>;
      })}

        <AnimatedCard delay={0}>
          <div className="mt-10 pt-8 border-t border-border">
            <h2 className="text-2xl font-black tracking-tight text-foreground mb-1">
              How We Evaluated The Top 5
            </h2>
            <p className="text-sm text-muted-foreground font-medium">Shade Improvement (30-Day Test)</p>
          </div>
        </AnimatedCard>
      </div>
    </section>;
}